import React from 'react'

const ReportAppContext = React.createContext({})

export default ReportAppContext
